// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import MenuItem from './MenuItem';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `MenuSelectableItem` is a part of [Menu](#!/Menu) component.
 * @since 0.0.57
 */
const MenuSelectableItem = _ref => {
  let {
    className,
    children,
    selected = false,
    baseClassName = `${CLS_PREFIX}menu__item`,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx(MenuItem, {
    className: classNames(baseClassName, className),
    icon: selected ? 'check-mark' : null,
    role: "menuitemcheckbox",
    "aria-checked": selected ? 'true' : 'false',
    ...props,
    children: children
  });
};
export default MenuSelectableItem;